import { H4 } from "../typography/H4";

export const PartnerManageOrderHeader = () => {
  return <H4 className="py-[22px] text-semantic-text-heading">발주 관리</H4>;
};
